export const naturalLog = (val: number) => {
  if (val === 0) {
    return 0
  }
  if (val < 0) {
    return -1 * Math.log(Math.abs(val) + 1)
  }
  return Math.log(val + 1)
}
